/**
 * Created by rak on 1/15/2016.
 */
'use strict';

angular.module('trackReporting')
  .controller('RepoVehicleDetailCtrl', function ($scope, widgetSettingsCreatorService, commonTrackService, $timeout, reportService, $stateParams, $filter, $translate, errorHandlingService) {
    //var device = {};
    $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
    var startDate = '';
    var endDate = '';
    var mainUrlDetails = '&page=map.device.full';
    var column = [];
    var reportOptions = ['tripReport', 'motionSummary', 'digitalInputDetailReport', 'eventCountByDay', 'deviceNearbyDevices'];
    var dateRangePickerSettings = {};
    var _selectedReportOption = '';
    var _selectedReportOptionModel = '';
    var lastlocationWidgetData = commonTrackService.getsetLastLocatioWidgetData();
    var radioCache = commonTrackService.getDataFromLocalStorage('vehicleDetailRadioName');
    $scope.isDataAvailable = true;
    $scope.radio = {
      name: $stateParams.reportName ? $stateParams.reportName : (radioCache ? radioCache : 'EventDetail')
    };

    $scope.reportDetail = {};
    $scope.repoVehicle = $stateParams.vehicleId;
    $scope.moduleName = 'vehicledetailsreport';
    var isGridCreated = false;
    $scope.reportComboOption = {
      tripReport: null,
      motionSummary: null,
      digitalInputDetailReport: null,
      eventCountByDay: null,
      deviceNearbyDevices: null
    };
    var reportPropertiesObject = reportService.vehicleDetailReportProperties();
    $scope.reportHistory = '';

    $scope.diableRepoTab = {
      report: true
    };

    $scope.showRepoTab = 0;

    var source =
      {
        datatype: 'array',
        datafields: [],
        localdata: []
      };
    $scope.date = {
      startDate: $stateParams.dateFrom ? new Date($stateParams.dateFrom.replaceAll('-', '/').replace('T', ' ')) : new Date(commonTrackService.formatReportDateTime($filter('date')(new Date(), 'dd/MM/yyyy'), '00:00:00')),
      endDate: $stateParams.dateFrom ? new Date($stateParams.dateTo.replaceAll('-', '/').replace('T', ' ')) : new Date()
    };

    $scope.vehicleDetailReportPropList = [{
      _isEnabled: true,
      _reportName: 'EventDetail',
      _idName: 'eventDetailRadio',
      _translationProp: 'trackReporting.vehicleDetailReport.eventDetail',
      _hasOption: false,
      _hasMap: true
    }, {
      _isEnabled: true,
      _reportName: 'EventDetailAll',
      _idName: 'eventDetailAllRadio',
      _translationProp: 'trackReporting.vehicleDetailReport.eventDetailAll',
      _hasOption: false,
      _hasMap: true
    }, {
      _isEnabled: true,
      _reportName: 'TripReport',
      _idName: 'tripReportRadio',
      _translationProp: 'trackReporting.vehicleDetailReport.tripReport',
      _hasOption: true,
      _comboID: 'tripreportComboBox',
      _comboModelName: 'tripReport',
      _comboSettings: 'tripReportSettings',
      _hasMap: false
    },
      {
        _isEnabled: true,
        _reportName: 'MotionSummary',
        _idName: 'motionSummaryRadio',
        _translationProp: 'trackReporting.vehicleDetailReport.motionSummary',
        _hasOption: true,
        _comboID: 'motionsummaryComboBox',
        _comboModelName: 'motionSummary',
        _comboSettings: 'motionSummarySettings',
        _hasMap: true
      },
      {
        _isEnabled: true,
        _reportName: 'DeviceWorkOrders',
        _idName: 'deviceWorkOrdersRadio',
        _translationProp: 'trackReporting.vehicleDetailReport.deviceWorkOrders',
        _hasOption: false,
        _hasMap: true
      },
      {
        _isEnabled: false,
        _reportName: 'GeozoneDriving',
        _idName: 'geozoneDrivingRadio',
        _translationProp: 'trackReporting.vehicleDetailReport.geozoneDriving',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: false,
        _reportName: 'JobReport',
        _idName: 'jobReportRadio',
        _translationProp: 'trackReporting.vehicleDetailReport.jobReport',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'DigitalInputDetailReport',
        _idName: 'digitalInputDetailReportRadio',
        _translationProp: 'trackReporting.vehicleDetailReport.digitalInputDetailReport',
        _hasOption: true,
        _comboID: 'digitalinputdetailreportComboBox',
        _comboModelName: 'digitalInputDetailReport',
        _comboSettings: 'digitalInputDetailReportSettings',
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'EventCountByDay',
        _idName: 'eventCountByDayRadio',
        _translationProp: 'trackReporting.vehicleDetailReport.eventCountByDay',
        _hasOption: true,
        _comboID: 'eventcountbydayComboBox',
        _comboModelName: 'eventCountByDay',
        _comboSettings: 'eventCountByDaySettings',
        _hasMap: false
      },
      {
        _isEnabled: false,
        _reportName: 'EventIdle',
        _idName: 'eventIdleRadio',
        _translationProp: 'trackReporting.vehicleDetailReport.eventIdle',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'DriverMessageDetail',
        _idName: 'driverMessageDetailRadio',
        _translationProp: 'trackReporting.vehicleDetailReport.driverMessageDetail',
        _hasOption: false,
        _hasMap: true
      },
      {
        _isEnabled: false,
        _reportName: 'EventDetailOBDLight',
        _idName: 'eventDetailOBDLightRadio',
        _translationProp: 'trackReporting.vehicleDetailReport.eventDetailOBDLight',
        _hasOption: false,
        _hasMap: false
      },

      {
        _isEnabled: true,
        _reportName: 'FuelRegisterDetail',
        _idName: 'fuelRegisterDetailRadio',
        _translationProp: 'trackReporting.vehicleDetailReport.fuelRegisterDetail',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'DailyDistanceDetail',
        _idName: 'dailyDistanceDetailRadio',
        _translationProp: 'trackReporting.vehicleDetailReport.dailyDistanceDetail',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: false,
        _reportName: 'DeviceNearbyDevices',
        _idName: 'deviceNearbyDevicesRadio',
        _translationProp: 'trackReporting.vehicleDetailReport.deviceNearbyDevices',
        _hasOption: true,
        _comboID: 'devicenearbydevicesComboBox',
        _comboModelName: 'deviceNearbyDevices',
        _comboSettings: 'deviceNearbyDevicesSettings',
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'EventDetailCargoQuality',
        _idName: 'eventDetailCargoQualityRadio',
        _translationProp: 'trackReporting.vehicleDetailReport.eventDetailCargoQuality',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'NotifyQueueDetail',
        _idName: 'notifyQueueDetailRadio',
        _translationProp: 'trackReporting.groupDetailReport.notifyQueueDetail_Group',
        _hasOption: false,
        _hasMap: false
      },
      {
        _isEnabled: true,
        _reportName: 'FuelTracker',
        _idName: 'fuelTrackerReportRadio',
        _translationProp: 'trackReporting.vehicleDetailReport.fuelTracker',
        _hasOption: false,
        _hasMap: false
      }
    ];
    var dateRangeCustomEventHandler = {
      eventHandlers: {
        'apply.daterangepicker': function () {
          startDate = $scope.date.startDate._isAMomentObject ? $scope.date.startDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
          endDate = $scope.date.startDate._isAMomentObject ? $scope.date.endDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');
          if ($scope.showRepoTab === 1) {
            $scope.getReport($scope.radio.name, $scope.hasMap, _selectedReportOptionModel);
          }
          /* $timeout(function () {
           $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, mainUrlDetails + '&group=' + device.value + '&date_fr=' + startDate + '&date_to=' + endDate);
           }, 0);*/
        }
      }
    };
    commonTrackService.getDatePickerDetails().then(function (settings) {
      $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler, commonTrackService.getDateRangePickerRange(settings,$scope.radio.name));
      dateRangePickerSettings = settings;
    });

    var loadFleetServerDetails = function () {
      return commonTrackService.getFleetServerDetails().then(function (fleetServerDetails) {
        $scope.fleetServerUrl = fleetServerDetails.qualifiedServerURL;
        $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, mainUrlDetails);
      });
    };

    $scope.repoVehicleSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'description',
      valueMember: 'deviceID'
    });

    $scope.tripReportSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });

    $scope.motionsummarySettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });

    $scope.motionSummarySettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });

    $scope.digitalInputDetailReportSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });

    $scope.eventCountByDaySettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });

    $scope.deviceNearbyDevicesSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });


    var loaddevice = function () {
      return commonTrackService.getDeviceComboList(false).then(function (vehicleList) {
        $scope.repoVehicleSettings.source = vehicleList;
        var cacheData = commonTrackService.getDataFromLocalStorage('vehicleDetailReport');
        if ($stateParams.vehicleId) {
          $scope.repoVehicle = $stateParams.vehicleId;
        } else if (lastlocationWidgetData.selectedRow && lastlocationWidgetData.selectedRow.deviceid) {
          $scope.repoVehicle = lastlocationWidgetData.selectedRow.deviceid;
        } else if (cacheData) {
          $scope.repoVehicle = cacheData;
        } else {
          $scope.repoVehicle = $scope.repoVehicleSettings.source[0].deviceID;
        }

      });
    };
    var loadReportOptions = function (name) {
      reportService.getCustomVehicleRepotOptionComboData(name).then(function (reportOptionData) {
        for (var i = 0; i < reportOptionData.length; i++) {
          reportOptionData[i].displayName = $translate.instant('trackReporting.vehicleDetailReport.reportComboboxOptions.' + name + '.' + reportOptionData[i].key);
        }
        $scope[name + 'Settings'].source = reportOptionData;
        $scope.reportComboOption[name] = reportOptionData[0].key;
      });
    };

    loadFleetServerDetails().then(function () {

      return loaddevice();
    }).finally(function () {
      $('#vhlDetailRepoSpliter').jqxSplitter(reportService.getReportSpliterWithMapPanel());

      for (var i = 0; i < reportOptions.length; i++) {
        loadReportOptions(reportOptions[i]);
      }
      initExport();
      $scope.dataLoadingFinished = true;
      $scope.isCreateCombobox = true;

      if ($stateParams.reportName && $stateParams.vehicleId && $stateParams.dateFrom && $stateParams.dateTo) {
        $timeout(function () {
          $scope.getReport($stateParams.reportName,  reportPropertiesObject[$stateParams.reportName] ? reportPropertiesObject[$stateParams.reportName].hasMap : false);

          $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').on('bindingcomplete', function () {
            isGridCreated = true;
            $timeout(function () {
              $('#vhlDetailRepoSpliter').jqxSplitter('render');
            }, 400);

          });
        }, 100);
      }
      $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').on('bindingcomplete', function () {
        isGridCreated = true;
        $timeout(function () {
          $('#vhlDetailRepoSpliter').jqxSplitter('render');
        }, 100);
      });

      $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').on('rowselect', function (event) {
        if (event.args && event.args.row) {
          if (event.args.row.timestamp) {
            commonTrackService.iframePostMessage('jsmShowDetailPushpinForRoute_Dsa(' + event.args.row.timestamp + ')', 'groupMap');

          }
          if ($scope.reportHistory === 'DeviceWorkOrders') {
            var _tmpStartDate = commonTrackService.formatReportDateTime(event.args.row.workorderstartdate, event.args.row.workorderstarttime, false);
            var _tmpEndDate = commonTrackService.formatReportDateTime(event.args.row.workorderenddate, event.args.row.workorderendtime, false);
            $scope.$apply(function () {
              $scope.mapUrl = commonTrackService.getReportMap($scope.fleetServerUrl, 'EventDetail', 'Device', $scope.repoVehicle, '', _tmpStartDate, _tmpEndDate);
              $scope.mapUrl += '&pushpins_dsa=all';
            });
          }
          if ($scope.reportHistory === 'MotionSummary' && event.args.row.startdatetime && event.args.row.stopdatetime) {
            var _tmpStartDateTime = commonTrackService.formatReportDateTime(event.args.row.startdatetime.split(' ')[0], event.args.row.startdatetime.split(' ')[1], false);
            var _tmpEndDateTime = commonTrackService.formatReportDateTime(event.args.row.stopdatetime.split(' ')[0], event.args.row.stopdatetime.split(' ')[1], false);
            $scope.$apply(function () {
              $scope.mapUrl = commonTrackService.getReportMap($scope.fleetServerUrl, 'EventDetail', 'Device', $scope.repoVehicle, '', _tmpStartDateTime, _tmpEndDateTime);
              $scope.mapUrl += '&pushpins_dsa=all';
            });
          }
        }
      });
    });

    $scope.getReport = function (reportName, hasMap, reportOption, event) {
      $scope.mapUrl = '';
      var gridState = reportService.getReportGridState('vehicleDetailReport', reportName);
      _selectedReportOptionModel = reportOption;

      $scope.error = false;
      $scope.exportOption = 'HTML';
      $scope.diableRepoTab.report = false;
      $scope.hasMap = hasMap;
      $scope.dataLoadingFinished = false;

      startDate = startDate && !startDate._isAMomentObject ? startDate : $filter('date')($scope.date.startDate._isAMomentObject ? $scope.date.startDate._d : $scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
      endDate = endDate && !endDate._isAMomentObject ? endDate : $filter('date')($scope.date.endDate._isAMomentObject ? $scope.date.endDate._d : $scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');
	  
	  // remove state param date range so that it is not used again
	  delete $stateParams.dateFrom;
	  delete $stateParams.dateTo;

      _selectedReportOption = $scope.reportComboOption[reportOption] && reportOption ? $scope.reportComboOption[reportOption] : '';

      var _tmpReportData = null;
      reportService.getVehilceReport($scope.moduleName, event ? event.args.item.value : $scope.repoVehicle, endDate, startDate, $scope.reportHistory !== reportName ? true : false, reportName, _selectedReportOption !== null ? _selectedReportOption : '').then(function (detailReport) {
        $scope.isDataAvailable = true;
        _tmpReportData = detailReport;
        if ($scope.reportHistory !== reportName) {
          $scope.reportHistory = reportName;
          source.localdata = detailReport.dataList;
          source.sort = commonTrackService.getCustomReportSortFunction($scope.overviewGridPrefix + 'vehicleDetailReportList', source);
          column = commonTrackService.getColumnProperties(detailReport.gridSettings.overviewListGrids[0].columnProperties, detailReport.columnTranslation, {
            moduleName: reportName,
            reportModel: 'vehicleDetailReport'
          });
          var _additionalProperties = {
            translatedName: $translate.instant('trackReporting.vehicleDetailReport.' + reportName.toLoawerCaseAt(0)),
            isDynamicGrid: true,
            dynamicModuleName: reportName
          };
          $scope.gridSettings = commonTrackService.getGridSettings('vehicleDetailReport', {
            pagesizeoptions: ['25', '50', '100'],
            pagesize: 25,
            columns: column,
            autosavestate: false,
            height: 730,
            autoloadstate: false
          }, null, _additionalProperties);
          $scope.dataAdapter = new $.jqx.dataAdapter(source);
          $scope.gridSettings.source = $scope.dataAdapter;
          // should be executed only after once successfully creating grid or else 'grid container will be lost', following needed for Jqx 4 changes.
          if (isGridCreated) {
            $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').jqxGrid({
              source: $scope.dataAdapter,
              columns: column
            });
          }
          $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').jqxGrid($scope.gridSettings);
        }
        else {
          source.localdata = detailReport.dataList;
          $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').jqxGrid('updatebounddata', 'data');
        }

        if ($scope.hasMap) {
          // code is not fool proof , 4 seconds wait is for map to show up and select event try to show pushpin if map is already there
          $timeout(function () {
            $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').jqxGrid('selectrow', 0);
          }, 4000);
        }

      }, function (response) {
        $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').jqxGrid('clear');
        $scope.reportHistory = '';
        $scope.mapUrl = '';
        if (errorHandlingService.errorForNoAuthorized(response)) {
          $scope.isDataAvailable = false;
        }
      }).finally(function () {

          $timeout(function () {
            $scope.showRepoTab = 1;
            if (!$scope.hasMap) {
              $('#vhlDetailRepoSpliter').jqxSplitter(reportService.getReportSplitterWithoutMapPannel());
            } else {
              $('#vhlDetailRepoSpliter').jqxSplitter(reportService.getReportSpliterWithMapPanel());

            }

            if ($scope.hasMap) {
              $scope.mapUrl = commonTrackService.getReportMap($scope.fleetServerUrl, reportName, 'Device', event ? event.args.item.value : $scope.repoVehicle, _selectedReportOption ? _selectedReportOption : '', startDate, endDate);
            }
            if (!$scope.isEventRegistered) {
              $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').on('filter', function () {
                saveGridSate();
              });
              $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').on('columnresized', function () {
                saveGridSate(reportName);
              });

              $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').on('columnreordered', function () {
                saveGridSate(reportName);
              });

              $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').on('sort', function () {
                saveGridSate(reportName);
              });
              $scope.isEventRegistered = true;
            }
          }, 0);
          $timeout(function () {
            var gridLocalStorageUserSettingKey = reportName + '-' + $scope.overviewGridPrefix + 'vehicleDetailReportList';
            reportService.loadReportCustomGridState(_tmpReportData, '#' + $scope.overviewGridPrefix + 'vehicleDetailReportList', $scope.gridSettings,gridState, gridLocalStorageUserSettingKey);
          }, 1000);
          column = null;
        }
      );
    }
    ;

    function saveGridSate() {
      var reportSate = $('#' + $scope.overviewGridPrefix + 'vehicleDetailReportList').jqxGrid('getstate');
      reportService.setReportGridState('vehicleDetailReport', $scope.radio.name, reportSate);
    }

    function initExport() {
      $scope.exportSetting = reportService.getExportSettings();
      $scope.exportSetting.selectedIndex = 0;
      $scope.exportOption = 'HTML';
    }

    $scope.exportChange = function (event) {
      $scope.exportURL = '';

      if (typeof event === 'object' && event.args && event.args.item.value !== 'EMail' && event.args.item.value !== 'HTML') {

        $scope.exportURL = commonTrackService.getExportURL( $scope.reportHistory, event.args.item.value, 'Device', $scope.repoVehicle, _selectedReportOption ? _selectedReportOption : '', startDate, endDate);
        reportService.doExport($scope.exportURL, $scope.reportHistory, event.args.item.value);

      } else {
        $scope.exportOption = typeof event === 'object' && event.args && event.args.item.value ? event.args.item.value : event;
        $scope.exportURL = commonTrackService.getExportURL( $scope.reportHistory, event, 'Device', $scope.repoVehicle, _selectedReportOption ? _selectedReportOption : '', startDate, endDate, $scope.reportDetail.emailAddresses);
        if (!event.args) {
          reportService.doExport($scope.exportURL, $scope.reportHistory, 'EMail');
        }
      }


    };
    $scope.repoVehicleComboChange = function (event) {
      var selectItem = event.args.item;
      if (selectItem) {
        commonTrackService.setDataToLocalStorage('vehicleDetailReport', selectItem.value);
      }
      if (event.args && event.args.item.value) {
        $scope.repoVehicle = event.args.item.value;
      }
      if ($scope.showRepoTab === 1) {

        $scope.getReport($scope.radio.name, $scope.hasMap, _selectedReportOptionModel, event);
      }


    };
    $scope.$watch('radio.name', function (value) {
      if (value) {
        commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings,value));
        var range = commonTrackService.getDateRangePickerRange(dateRangePickerSettings,value);
		  if ($stateParams.dateFrom && $stateParams.dateTo && $stateParams.hasCustomDateRange) {
			$scope.date = {
			  startDate : new Date($stateParams.dateFrom.replaceAll('-', '/').replace('T', ' ')),
              endDate : new Date($stateParams.dateTo.replaceAll('-', '/').replace('T', ' ')) 
			};
          } else if(range === commonTrackService.dateRange.SHORT) {
            $scope.date = {
              startDate: moment().clone().startOf('day'),
              endDate: moment()
            };
          } else if (range === commonTrackService.dateRange.MID) {
            $scope.date = {
              startDate: moment().clone().startOf('week'),
              endDate: moment()
            };
          }
        startDate = $scope.date.startDate._isAMomentObject ? $scope.date.startDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
        endDate = $scope.date.startDate._isAMomentObject ? $scope.date.endDate.format('YYYY/MM/DD/HH:mm:ss') : $filter('date')($scope.date.endDate, 'yyyy/MM/dd/HH:mm:ss');

        // after new layout 4 $parent is required to keep breadcrump to keep the link ( better solution have to be found)
        $scope.$parent.breadCrumbLabel = $translate.instant('trackReporting.vehicleDetail') + ' / ' + $translate.instant('trackReporting.vehicleDetailReport.' + $scope.radio.name._toLowerCaseAtIndex(0));
        $scope.$parent.$parent.$parent.$parent.breadCrumbLabel = $translate.instant('trackReporting.vehicleDetail') + ' / ' + $translate.instant('trackReporting.vehicleDetailReport.' + $scope.radio.name._toLowerCaseAtIndex(0));
        commonTrackService.setDataToLocalStorage('vehicleDetailRadioName', value);
      }
    });
    $scope.cancel = function () {
      $scope.showRepoTab = 0;
    };
    var updateDateRangeInternalDateEvent = $scope.$on('date-range-internalDate-old', function () {
      $scope.options.ranges = commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings,$scope.radio.name));
      angular.element('#daterange4').trigger('show.daterangepicker');
    });

    $scope.$on('$destroy', function () {
      updateDateRangeInternalDateEvent();
      if ($scope.dataAdapter) {
        delete  $scope.dataAdapter;
      }
      if ($scope.gridSettings && $scope.gridSettings.source) {
        delete $scope.gridSettings.source;
      }
    });

  });



// WEBPACK FOOTER //
// ./.tmp/components/track/reports/vehicleDetailReportController.js